import Seller from "./From/Seller";
import Source from "./From/Source";
import Customer from "./To/Customer";
import Target from "./To/Target";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import classNames from "classnames";
import Buttons from "./Buttons";
import List from './List';
import isEqual from "lodash-es/isEqual";
import connect from "react-redux/es/connect/connect";
import Box from "../../../layout/Box";
import Shipping from "./Shipping";

class WholeSaleConsignmentForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                theme="default"
                body={
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-4">
                                <Target {...componentProps} />
                            </div>
                        </div>
                        <div className="row form-row">
                            <Shipping {...componentProps} control={{hidden: ['origin','serviceprovider']}} />
                        </div>
                        <Comment {...componentProps} />
                        <PoolList {...componentProps} control={{visible: false}}/>
                    </form>
                }
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            />
        </Fragment>;
    }
}


export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(WholeSaleConsignmentForm);